import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Search } from "lucide-react";
import api from "../api";
import { useApp } from "../context/AppContext";
import { Button } from "./ui/button";
import { toast } from "sonner";

const DOC_TYPES = ["7/12 Utara", "8-A / Khata", "Ferfar", "Property Card", "Index-2", "Certified Copy", "EC", "ROR", "Village Map"];

export function SearchBox() {
  const { t } = useApp();
  const navigate = useNavigate();
  const [districts, setDistricts] = useState([]);
  const [talukas, setTalukas] = useState([]);
  const [villages, setVillages] = useState([]);
  const [sros, setSros] = useState([]);
  const [form, setForm] = useState({
    state: "Gujarat", district: "", taluka: "", village: "", sro: "",
    document_type: "", survey_number: "", document_number: "", registration_year: "",
  });

  useEffect(() => { api.get("/districts").then((r) => setDistricts(r.data)).catch(() => {}); }, []);

  const onDistrict = (id) => {
    setForm({ ...form, district: id, taluka: "", village: "", sro: "" });
    setTalukas([]); setVillages([]); setSros([]);
    if (id) {
      api.get(`/districts/${id}/talukas`).then((r) => setTalukas(r.data)).catch(() => {});
      api.get(`/districts/${id}/sros`).then((r) => setSros(r.data)).catch(() => {});
    }
  };
  const onTaluka = (id) => {
    setForm({ ...form, taluka: id, village: "" });
    setVillages([]);
    if (id) api.get(`/talukas/${id}/villages`).then((r) => setVillages(r.data)).catch(() => {});
  };

  const submit = async (e) => {
    e.preventDefault();
    try {
      const distName = districts.find((d) => d.id === form.district)?.name || "";
      const payload = { ...form, district: distName,
        taluka: talukas.find((x) => x.id === form.taluka)?.name || "",
        village: villages.find((x) => x.id === form.village)?.name || "",
        sro: sros.find((x) => x.id === form.sro)?.name || "" };
      const { data } = await api.post("/search", payload);
      if (data.matched) toast.success(data.matched.message);
      else toast.info("No direct match. Submit a document request and our team will assist.");
      navigate("/services");
    } catch {
      toast.error("Search failed. Please try again.");
    }
  };

  const sel = "w-full h-11 rounded-md border border-input bg-white px-3 text-sm focus:outline-none focus:ring-2 focus:ring-ring";
  const input = sel;

  return (
    <form onSubmit={submit} className="bg-white rounded-2xl shadow-xl border border-border p-5 md:p-6" data-testid="property-search-box">
      <h3 className="font-display font-bold text-lg mb-4 text-foreground">{t("search_title")}</h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-3">
        <select className={sel} value={form.state} disabled data-testid="search-state"><option>Gujarat</option></select>
        <select className={sel} value={form.district} onChange={(e) => onDistrict(e.target.value)} data-testid="search-district">
          <option value="">{t("district")}</option>
          {districts.map((d) => <option key={d.id} value={d.id}>{d.name}</option>)}
        </select>
        <select className={sel} value={form.taluka} onChange={(e) => onTaluka(e.target.value)} data-testid="search-taluka">
          <option value="">{t("taluka")}</option>
          {talukas.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
        </select>
        <select className={sel} value={form.village} onChange={(e) => setForm({ ...form, village: e.target.value })} data-testid="search-village">
          <option value="">{t("village")}</option>
          {villages.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
        </select>
        <select className={sel} value={form.sro} onChange={(e) => setForm({ ...form, sro: e.target.value })} data-testid="search-sro">
          <option value="">{t("sro")}</option>
          {sros.map((x) => <option key={x.id} value={x.id}>{x.name}</option>)}
        </select>
        <select className={sel} value={form.document_type} onChange={(e) => setForm({ ...form, document_type: e.target.value })} data-testid="search-document-type">
          <option value="">{t("document_type")}</option>
          {DOC_TYPES.map((d) => <option key={d}>{d}</option>)}
        </select>
        <input className={input} placeholder={t("survey_number")} value={form.survey_number}
          onChange={(e) => setForm({ ...form, survey_number: e.target.value })} data-testid="search-survey-number" />
        <input className={input} placeholder={t("document_number")} value={form.document_number}
          onChange={(e) => setForm({ ...form, document_number: e.target.value })} data-testid="search-document-number" />
        <input className={input} placeholder={t("registration_year")} value={form.registration_year}
          onChange={(e) => setForm({ ...form, registration_year: e.target.value })} data-testid="search-registration-year" />
        <Button type="submit" className="h-11 bg-primary hover:bg-primary/90" data-testid="search-submit-btn">
          <Search size={16} className="mr-1" /> {t("search")}
        </Button>
      </div>
    </form>
  );
}
